<a *ngFor="let item of navRoutes" [routerLink]="item.route" [routerLinkActive]="'active'">
	{{ item.name | translate }}
</a>
